import { MultiTraitQueryComponent } from './multi-trait-query.component';
import { BmsjHipsterSharedModule } from '../shared';
import { RouterModule } from '@angular/router';
import { MULTI_TRAIT_QUERY_ROUTES } from './multi-trait-query.routes';
import { MultiTraitQueryService } from './multi-trait-query.service';
import { MultiTraitQueryContext } from './multi-trait-query-context';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { NgModule, viewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { StepIntroductionComponent } from './introduction-step-panel/step-introduction.component';
import { StepSelectTraitsComponent, TraitTreeComponent } from './select-traits-step-panel/step-select-traits.component';
import { StepSpecifyAndWeightTheEnvironmentsComponent } from './specify-and-weight-environment/step-specify-and-weight-the-environments.component';
import { StepSetupTheTraitFilterComponent } from './setup-trait-filter-step-panel/step-setup-the-trait-filter.component';
import { NumberTraitsPaneComponent } from './setup-trait-filter-step-panel/traits-panel/number-traits-pane.component';
import { CharacterTraitsPaneComponent } from './setup-trait-filter-step-panel/traits-panel/character-traits-pane.component';
import { CategoricalTraitsPaneComponent } from './setup-trait-filter-step-panel/traits-panel/categorical-traits-pane.component';
import { StepDisplayResultsComponent } from './dispaly-result-step-panel/step-display-results.component';
import { TruncateSpanComponent } from '../shared/util/span-truncate/truncate-span.component';
import { TraitFilterContext } from './setup-trait-filter-step-panel/trait-filter-context';
import { TraitObservationComponent, TraitObservationPopupComponent } from './setup-trait-filter-step-panel/traits-panel/trait-observation/trait-observation.component';
import { QueryService } from '../shared/query/service/query.service';
import { HelpLinkComponent } from '../shared/help-link/help-link.component';

@NgModule({
    imports: [
        BmsjHipsterSharedModule,
        MatButtonModule,
        MatExpansionModule,
        RouterModule.forChild(MULTI_TRAIT_QUERY_ROUTES),
        TruncateSpanComponent,
        HelpLinkComponent
    ],
    declarations: [
        MultiTraitQueryComponent,
        StepIntroductionComponent,
        StepSelectTraitsComponent,
        StepSpecifyAndWeightTheEnvironmentsComponent,
        StepSetupTheTraitFilterComponent,
        StepDisplayResultsComponent,
        TraitTreeComponent,
        NumberTraitsPaneComponent,
        CharacterTraitsPaneComponent,
        CategoricalTraitsPaneComponent,
        TraitObservationComponent,
        TraitObservationPopupComponent
    ],
    providers: [
        QueryService,
        MultiTraitQueryService,
        MultiTraitQueryContext,
        TraitFilterContext
    ],
})
export class MultiTraitQueryModule {
    accordion = viewChild.required(MatAccordion);
}
